import { NavLink } from "react-router-dom";
import { Receipt, BarChart3 } from "lucide-react";

export const CommTabs = () => {
  const base = "flex min-w-0 min-h-11 items-center justify-center gap-1 sm:gap-1.5 text-[11px] sm:text-sm font-medium px-1 sm:px-4 py-2 rounded-md transition-colors [&>svg]:shrink-0";
  return (
    <div className="grid grid-cols-2 sm:flex gap-1 bg-slate-100 p-1 rounded-lg sm:w-fit mb-5" data-testid="comm-tabs">
      <NavLink
        to="/communication"
        end
        data-testid="tab-facturation"
        className={({ isActive }) =>
          `${base} ${isActive ? "bg-white text-[#26788A] shadow-sm" : "text-slate-500 hover:text-slate-700"}`
        }
      >
        <Receipt size={15} /> Facturation
      </NavLink>
      <NavLink
        to="/communication/statistiques"
        data-testid="tab-statistiques"
        className={({ isActive }) =>
          `${base} ${isActive ? "bg-white text-[#26788A] shadow-sm" : "text-slate-500 hover:text-slate-700"}`
        }
      >
        <BarChart3 size={15} /> Statistiques
      </NavLink>
    </div>
  );
};
